




























































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator'
import type Server from '@tridoc/frontend'

@Component({})
export default class CommentsList extends Vue {
  @Prop() id!: string;
  @PropSync('meta') docMeta !: tdDocMeta
  allTags: tdTag[] = []

  loading = true

  comment = ''
  valid = false
  commentRules: FormRule[] = [
    v => !!v || 'Can’t make empty comments',
  ]

  async add () {
    this.valid = (this.$refs.form as any).validate()
    if (this.valid) {
      this.$store.getters.server.server.addComment(this.id, this.comment)
        .then(() => {
          (this.$refs.form as any).reset()
          this.reload()
        })
    } else {
    }
  }

  reload () {
    (this.$store.getters.server.server as Server).getMeta(this.id)
      .then(r => {
        this.loading = false
        if (!('error' in r)) {
          this.$emit('update:meta', { ...r, identifier: this.id })
        }
      })
  }

  created () {
    this.reload()
  }
}
